
export const populationData = [{
    arg: 1960,
    val: 3032019978,
  }, {
    arg: 1970,
    val: 3683676306,
  }, {
    arg: 1980,
    val: 4434021975,
  }, {
    arg: 1990,
    val: 5281340078,
  }, {
    arg: 2000,
    val: 6115108363,
  }, {
    arg: 2010,
    val: 6922947261,
  }, {
    arg: 2020,
    val: 7795000000,
  }];
  